<template>
  <div class="project" :style="cssProps">
    <!-- left column -->
    <div class="left-container">
      <div class="left-container-content" :class="loaded ? '' : 'anim'">
        <h1 v-resize-text="{ ratio: 0.55 }"><a href="/">Blue Temple</a></h1>
        <div class="left-container-d-wrapper">
          <div
            class="left-container-d-title-col left-container-d-title-col--r90deg"
          >
            <span class="left-container-title">{{ project.name }}</span>
            <span class="left-container-type">{{
              project.type.data.name
            }}</span>
          </div>

          <div class="left-container-d-content">
            <img
              :src="project.cover[0]"
              :alt="coverSeo.alt"
              :title="coverSeo.title"
            />
            <div
              class="left-container-d-title-col left-container-d-title-col--normal"
            >
              <span class="left-container-title">{{ project.name }}</span>
              <span class="left-container-type">{{
                project.type.data.name
              }}</span>
            </div>
            <span class="left-container-location">{{
              project.location.data.name
            }}</span>
            <span class="left-container-chronology">{{ project.year }}</span>
            <span class="left-container-scale">{{ project.scale }}</span>
            <span>-</span>
            <span class="left-container-status">{{
              project.status.data.name
            }}</span>
            <span>-</span>
            <p class="left-container-excerpt">{{ project.info }}</p>

            <a
              class="left-container-download"
              :href="project.googleDrive"
              v-if="project.googleDrive"
              target="_blank" rel="noopener noreferrer"
              >Download files</a
            >

            <router-link to="/" class="left-container-backtoproject"
              >&lt; Back to projects</router-link
            >
          </div>
        </div>

        <div class="footer">
          <!-- Social Icons -->
          <ul class="menu-social">
            <li class="menu-social-item">
              <a
                :href="'mailto:' + socialUrls.email"
                class="menu-social-item--email"
                ><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                  <path
                    d="M464 64H48a48 48 0 00-48 48v288a48 48 0 0048 48h416a48 48 0 0048-48V112a48 48 0 00-48-48zm0 32c2.2 0 4.2.5 6.1 1.2L256 282.8 41.9 97.2c1.9-.8 4-1.2 6.1-1.2h416zm0 320H48a16 16 0 01-16-16V131l213.5 185a16.1 16.1 0 0021 0L480 131v269a16 16 0 01-16 16z"
                  /></svg
              ></a>
            </li>
            <li class="menu-social-item">
              <a
                :href="socialUrls.ig"
                target="_blank" rel="noopener noreferrer"
                class="menu-social-item--instagram"
                ><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 511 511">
                  <path
                    d="M510.5 150.2a186.4 186.4 0 00-11.9-62 125.6 125.6 0 00-29.5-45.3 124.9 124.9 0 00-45.2-29.4 187 187 0 00-62-11.9C334.5.3 325.8 0 256.4 0s-78.1.3-105.3 1.5a186.4 186.4 0 00-62 11.9 125.1 125.1 0 00-45.3 29.5 124.9 124.9 0 00-29.4 45.2 187 187 0 00-11.9 62C1.2 177.5.9 186.1.9 255.5s.3 78.1 1.5 105.3c1.2 27.2 5.6 45.8 11.9 62a127 127 0 0029.5 45.3c12.8 13 28.3 23.1 45.2 29.4a187 187 0 0062 11.9c27.2 1.2 35.9 1.5 105.3 1.5s78.1-.3 105.3-1.5c27.2-1.2 45.8-5.6 62-11.9a130.9 130.9 0 0074.8-74.8 187 187 0 0011.9-62c1.2-27.3 1.5-35.9 1.5-105.3s-.1-77.9-1.3-105.2zm-46 208.7c-1.1 25-5.3 38.4-8.8 47.4a84.9 84.9 0 01-48.5 48.5c-9 3.5-22.6 7.7-47.4 8.8-27 1.2-35 1.5-103.2 1.5s-76.4-.3-103.2-1.5c-25-1.1-38.4-5.3-47.4-8.8a77.6 77.6 0 01-29.3-19.1 80 80 0 01-19.1-29.3c-3.5-9-7.7-22.6-8.8-47.4-1.2-27-1.5-35-1.5-103.2s.3-76.4 1.5-103.2c1.1-25 5.3-38.4 8.8-47.4a75.6 75.6 0 0119.1-29.4A80 80 0 01106 56.7c9-3.5 22.6-7.7 47.4-8.8 27-1.2 35-1.5 103.2-1.5 68.3 0 76.4.3 103.2 1.5 25 1.1 38.4 5.3 47.4 8.8a77.6 77.6 0 0129.3 19.1c8.5 8.3 15 18.3 19.1 29.4 3.5 9 7.7 22.6 8.8 47.4 1.2 27 1.5 35 1.5 103.2s-.2 76.1-1.4 103.1z"
                  />
                  <path
                    d="M256.4 124.3a131.3 131.3 0 100 262.6 131.3 131.3 0 000-262.6zm0 216.4a85.2 85.2 0 110-170.4 85.2 85.2 0 010 170.4zM423.6 119.1a30.6 30.6 0 11-61.2 0 30.6 30.6 0 0161.2 0z"
                  /></svg
              ></a>
            </li>
            <li class="menu-social-item">
              <a
                :href="socialUrls.fb"
                target="_blank" rel="noopener noreferrer"
                class="menu-social-item--facebook"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 682.7 682.7"
                >
                  <path
                    d="M625.7 21H56.3A35.3 35.3 0 0021 56.3v569.4A35.3 35.3 0 0056.3 661h306.5V413.5h-83.1v-96.9h83.1v-71.3c0-82.7 50.5-127.7 124.2-127.7 35.3 0 65.7 2.6 74.5 3.8v86.4h-50.9c-40.1 0-47.9 19.1-47.9 47.1v61.7h95.9l-12.5 96.9h-83.4V661h162.8a35.3 35.3 0 0035.3-35.3V56.3A35 35 0 00625.7 21z"
                  />
                </svg>
              </a>
            </li>
            <li class="menu-social-item">
              <a
                :href="socialUrls.li"
                target="_blank" rel="noopener noreferrer"
                class="menu-social-item--linkedin"
                ><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 510 510">
                  <path
                    d="M459 0H51C23 0 0 22.9 0 51v408c0 28 23 51 51 51h408c28 0 51-23 51-51V51c0-28.1-23-51-51-51zM153 433.5H76.5V204H153v229.5zm-38.2-272.9c-25.5 0-45.9-20.4-45.9-45.9s20.4-45.9 45.9-45.9 45.9 20.4 45.9 45.9-20.5 45.9-45.9 45.9zm318.7 272.9H357V298.4c0-20.4-17.9-38.2-38.2-38.2s-38.2 17.9-38.2 38.2v135.1H204V204h76.5v30.6a82.5 82.5 0 0163.8-35.7 90.3 90.3 0 0189.2 89.3v145.3z"
                  /></svg
              ></a>
            </li>
          </ul>
          <router-link to="/getinvolved" class="get-involved-cta"
            >get involved</router-link
          >
        </div>
      </div>
    </div>

    <!-- /left column -->

    <!-- ruler indicator -->
    <div class="ruler-indicator" :data-index="currentVisible">
      <div
        v-for="(sectionRuler, index) in sectionRuler"
        :key="index"
        class="ruler-indicator-block"
        :class="loaded ? '' : 'anim'"
      >
        <ul>
          <li class="line"></li>
          <li class="line"></li>
          <li class="line"></li>
          <li class="number">
            <a @click="scrollToSection(index)">{{ sectionRuler.number }}</a>
            <span>{{ sectionRuler.text }}</span>
          </li>
          <li class="line"></li>
          <li class="line"></li>
          <li class="line"></li>
        </ul>
      </div>
    </div>

    <!-- Content start -->
    <!-- *** image zoom *** -->
    <div class="project-image-preview">
      <img src="" alt="image zoom preview" />
    </div>

    <!-- section -->
    <div
      class="project-section project-section--hero project-section--wide chapter-line"
      ref="section-1"
      v-observe-visibility="{
        callback: visibilityChanged,
        intersection: {
          threshold: 0.7
        }
      }"
      data-index="1"
    >
      <!-- load it -->
      <!-- <button
        class="button load-it"
        type="button"
        name="button"
        v-show="!showEmbed"
        @click="showEmbed = true"
      >
        Load it
      </button> -->
      <div
        v-html="project.intro"
        class="project-embed show"
        :class="showEmbed ? 'show' : ''"
      ></div>

      <!-- <div class="project-section--hero--m">
        <img
          class="project-hero"
          :src="project.cover[0]"
          :alt="coverSeo.alt"
          :title="coverSeo.title"
        />
      </div> -->

      <a @click="scrollToSection(1)">
        <svg
          v-bind:style="{ fill: customColor }"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 70 70"
        >
          <path d="M17 27l2.8-2.8L35 39.4l15.2-15.2L53 27 35 45z" />
        </svg>
      </a>
    </div>

    <!-- section Mobile -->
    <div class="project-section project-section--m">
      <div class="project-section-inner">
        <h2>{{ project.name }}</h2>
        <h3>{{ project.type.data.name }}</h3>
        <p>{{ project.info }}</p>
      </div>

      <div class="project-section-inner project--cols">
        <div
          class="project-icon"
          v-bind:style="{
            'background-image': 'url(' + project.animation + ')'
          }"
        ></div>
        <div class="project-details">
          <h4>{{ project.location.data.name }}</h4>
          <h4>{{ project.year }}</h4>
          <h4>{{ project.scale }}</h4>
          <h4><span>-</span>{{ project.status.data.name }}<span>-</span></h4>
          <h4>
            <a
              :href="project.googleDrive"
              v-if="project.googleDrive"
              target="_blank" rel="noopener noreferrer"
              >Download files</a
            >
          </h4>
        </div>
      </div>
    </div>

    <!-- section -->
    <div
      class="project-section project--cols chapter-margintop height50"
      ref="section-2"
      v-observe-visibility="{
        callback: visibilityChanged,
        intersection: {
          threshold: 0.7
        }
      }"
      data-index="2"
    >
      <div
        class="project-section-inner project-section-inner--1 project--cols project-section--d"
      >
        <div
          class="project-icon"
          v-bind:style="{
            'background-image': 'url(' + project.animation + ')'
          }"
        ></div>

        <div
          class="project-section project-section--border project-section--nomargin"
          v-bind:style="{ borderColor: customColor }"
        >
          <div class="project-section-inner">
            <h5 v-bind:style="{ color: customColor }">Team</h5>
          </div>
          <ul class="team-members">
            <li v-for="(member, index) in project.team" :key="index">
              <a v-if="member.url" :href="member.url" target="_blank" rel="noopener noreferrer">{{
                member.name
              }}</a>
              <span v-else>{{ member.name }}</span>
            </li>
          </ul>
        </div>
      </div>

      <div
        class="project-section-inner project-section-inner--2 project-section--border"
        v-bind:style="{ borderColor: customColor }"
      >
        <h5 v-bind:style="{ color: customColor }">Project Goal</h5>
        <div class="tab-content-wrapper" :class="{ active: showMore }">
          <p v-html="project.goal"></p>
        </div>
        <a class="project-section-more" v-on:click="myFilter">{{
          this.showMoreText
        }}</a>
      </div>
    </div>

    <!-- section: Team -->
    <!-- <div
      class="project-section--d-wrapper chapter-line chapter-marginbottom height50"
    >
      <div
        class="project-section project-section--border"
        v-bind:style="{ borderColor: customColor }"
      >
        <div class="project-section-inner">
          <h5 v-bind:style="{ color: customColor }">Team</h5>
        </div>
        <ul class="team-members">
          <li v-for="(member, index) in project.team" :key="index">
            <a v-if="member.url" :href="member.url" target="_blank" rel="noopener noreferrer">{{
              member.name
            }}</a>
            <span v-else>{{ member.name }}</span>
          </li>
        </ul>
      </div>
    </div> -->

    <!-- section -->
    <div
      class="project-section project-section--images chapter-margintop chapter-line"
      ref="section-3"
      v-observe-visibility="{
        callback: visibilityChanged,
        intersection: {
          threshold: 0.7
        }
      }"
      data-index="3"
      v-bind:style="{ borderColor: customColor }"
    >
      <img
        v-for="(smallGalleryImage, index) in smallGalleryImages"
        :key="index"
        :src="smallGalleryImage.url"
        :alt="smallGalleryImage.alt"
        v-on:mouseover="galleryPreviewShow(smallGalleryImage)"
        v-on:mouseleave="galleryPreviewHide"
        class="project-image"
      />
    </div>

    <div
      class="chapter-margintop chapter-margintop--nopadding"
      ref="section-4"
      v-observe-visibility="{
        callback: visibilityChanged,
        intersection: {
          threshold: 0.7
        }
      }"
      data-index="4"
    >
      <VueSlickCarousel class="slickSlide1" ref="slick1" :asNavFor="$refs.slick2" v-bind="settings">
        <div
          v-for="(largeGalleryImage, index) in largeGalleryImages"
          :key="index"
        >
          <img :src="largeGalleryImage.url" :alt="largeGalleryImage.alt" />
        </div>
      </VueSlickCarousel>

      <!-- Desktop slider nav -->
      <VueSlickCarousel class="slickSlide2 slickSlide2--d" ref="slick2" :asNavFor="$refs.slick1" v-bind="settingsSliderNav">
        <div
          v-for="(largeGalleryImage, index) in largeGalleryImages"
          :key="index"
        >
          <img :src="largeGalleryImage.url" :alt="largeGalleryImage.alt" />
        </div>
      </VueSlickCarousel>

      <!-- Mobile slider nav -->
      <VueSlickCarousel class="slickSlide2 slickSlide2--m" ref="slick2" :asNavFor="$refs.slick1" v-bind="settingsSliderNavMobile">
        <div
          v-for="(largeGalleryImage, index) in largeGalleryImages"
          :key="index"
        >
          <img :src="largeGalleryImage.url" :alt="largeGalleryImage.alt" />
        </div>
      </VueSlickCarousel>

      <!-- <hooper :settings="hooperSettings" ref="hooper">
        <slide
          v-for="(largeGalleryImage, index) in largeGalleryImages"
          :key="index"
        >
          <img :src="largeGalleryImage.url" :alt="largeGalleryImage.alt" />
        </slide>
        <hooper-navigation slot="hooper-addons"></hooper-navigation>
        <hooper-pagination slot="hooper-addons"></hooper-pagination>
      </hooper> -->

      <!-- Mobile Images instead of Slideshow -->
      <div
          v-for="(largeGalleryImage, index) in largeGalleryImages"
          :key="index"
          class="mobile-gallery"
        >
          <img :src="largeGalleryImage.url" :alt="largeGalleryImage.alt" />
        </div>
    </div>

    <!-- section EXTERNAL LINKS -->
    <div
      class="project-section--links chapter-margintop height50"
      ref="section-5"
      v-observe-visibility="{
        callback: visibilityChanged,
        intersection: {
          threshold: 0.7
        }
      }"
      data-index="5"
    >
      <div
        class="project-section project-section--border project-section-inner--1 "
        v-bind:style="{ borderColor: customColor }"
      >
        <h5 v-bind:style="{ color: customColor }">Internal Links</h5>
        <ol>
          <li v-for="(award, index) in project.awards" :key="index">
            <a v-if="award.url" :href="award.url" target="_blank" rel="noopener noreferrer">{{
              award.name
            }}</a>
            <span v-else>{{ award.name }}</span>
          </li>
        </ol>
      </div>

      <!-- section Awards/INTERNAL LINKS -->
      <div
        class="project-section project-section--border project-section-inner--1"
        v-bind:style="{ borderColor: customColor }"
      >
        <h5 v-bind:style="{ color: customColor }">External Links</h5>
        <ol>
          <li v-for="(links, index) in project.externalLinks" :key="index">
            <a v-if="links.url" :href="links.url" target="_blank" rel="noopener noreferrer">{{
              links.name
            }}</a>
            <span v-else>{{ links.name }}</span>
          </li>
        </ol>
      </div>

      <!-- section Grants -->
      <!-- <div
        class="project-section project-section--border project-section-inner--1"
        v-bind:style="{ borderColor: customColor }"
      >
        <h5 v-bind:style="{ color: customColor }">Grants</h5>
        <ol>
          <li v-for="(grant, index) in project.grants" :key="index">
            <a v-if="grant.url" :href="grant.url" target="_blank" rel="noopener noreferrer">{{
              grant.name
            }}</a>
            <span v-else>{{ grant.name }}</span>
          </li>
        </ol>
      </div> -->
    </div>

    <!-- section -->
    <div
      class="project-section project-section--border project-section--contact height25"
      v-bind:style="{ borderColor: customColor }"
    >
      <h5 v-bind:style="{ color: customColor }">Contact</h5>
      <div class="contact-wrapper">
        <p class="project-section-content-text">
          {{ project.contactText }}
        </p>
        <div>
          <span v-if="project.contactEmail">
            <span>E-MAIL:</span>
            <span
              ><a :href="'mailto:' + project.contactEmail">{{
                project.contactEmail
              }}</a></span
            >
          </span>
          <span v-if="project.contactPhone">
            <span>PHONE</span>
            <span
              ><a :href="`tel:${project.contactPhone}`">{{
                project.contactPhone
              }}</a></span
            >
          </span>
        </div>
      </div>
    </div>

    <!-- footer -->
    <!-- <div class="project-section project-section--footer">
      <div class="project-section--footer-block">
        <router-link v-bind:to="'/project/' + prevProject.slug">
          <span>&lt; Previous Case</span>
          {{ prevProject.title }}
        </router-link>
      </div>
      <div class="project-section--footer-block">
        <router-link v-bind:to="'/project/' + nextProject.slug">
          <span>Next Case &gt;</span>
          {{ nextProject.title }}
        </router-link>
      </div>
    </div> -->

    <div class="project-footer">
      <router-link
        v-if="prevProject.slug"
        class="project-footer-block"
        v-bind:to="'/project/' + prevProject.slug"
      >
        <router-link v-bind:to="'/project/' + prevProject.slug">
          <span>&lt; previous case</span>
          {{ prevProject.title }}
        </router-link>
      </router-link>

      <router-link
        v-if="!prevProject.slug && lastProject.slug"
        class="project-footer-block"
        v-bind:to="'/project/' + lastProject.slug"
      >
        <router-link v-bind:to="'/project/' + lastProject.slug">
          <span>&lt; previous case</span>
          {{ lastProject.title }}
        </router-link>
      </router-link>

      <router-link
        v-if="nextProject.slug"
        class="project-footer-block"
        v-bind:to="'/project/' + nextProject.slug"
      >
        <router-link v-bind:to="'/project/' + nextProject.slug">
          <span>next case &gt;</span>
          {{ nextProject.title }}
        </router-link>
      </router-link>

      <router-link
        v-if="!nextProject.slug && firstProject.slug"
        class="project-footer-block"
        v-bind:to="'/project/' + firstProject.slug"
      >
        <router-link v-bind:to="'/project/' + firstProject.slug">
          <span>next case &gt;</span>
          {{ firstProject.title }}
        </router-link>
      </router-link>
    </div>
  </div>
</template>

<script>
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
// optional style for arrows & dots
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";

//
// import {
//   Hooper,
//   Slide,
//   Navigation as HooperNavigation,
//   Pagination as HooperPagination
// } from "hooper";
// import "hooper/dist/hooper.css";

import axios from "axios";
import fetchAllPages from "@/utils/fetchAllPages";
import ResizeText from "vue-resize-text";

export default {
  name: "MyComponent",
  directives: {
    ResizeText
  },
  components: {
    VueSlickCarousel
    // Hooper,
    // Slide,
    // HooperNavigation,
    // HooperPagination
  },
  data() {
    return {
      project: {},
      coverSeo: {
        alt: "",
        title: ""
      },
      loaded: false,
      showEmbed: false,
      myOptions: {
        navButtons: true
      },
      // hooperSettings: {
      // itemsToShow: 1,
      //  infiniteScroll: true,
      //  wheelControl: false
      // },
      settings: {
        arrows: true,
        dots: false
      },
      settingsSliderNav: {
        arrows: true,
        dots: false,
        centerMode: true,
        slidesToShow: 5,
        focusOnSelect: true
      },
      settingsSliderNavMobile: {
        arrows: false,
        dots: false,
        centerMode: true,
        slidesToShow: 3,
        focusOnSelect: true
      },
      slug: this.$route.params.slug,
      projectTitle: "",
      projectMetaDescription: "",
      customColor: "#ffffff",
      showMore: false,
      showMoreText: "More",
      isVisible: false,
      currentVisible: 0,
      socialUrls: [],
      smallGalleryImages: [],
      largeGalleryImages: [],
      prevProject: {
        slug: "",
        title: "",
        img: ""
      },
      nextProject: {
        slug: "",
        title: "",
        img: ""
      },
      lastProject: {
        slug: "",
        title: "",
        img: ""
      },
      firstProject: {
        slug: "",
        title: "",
        img: ""
      },
      sectionRuler: [
        {
          number: "01",
          text: "Project Intro"
        },
        {
          number: "02",
          text: "Project Goal"
        },
        {
          number: "03",
          text: "Project Images"
        },
        {
          number: "04",
          text: "Slideshow"
        },
        {
          number: "05",
          text: "Extra Info"
        }
      ]
    };
  },

  // metaInfo: {
  //   // Children can override the title.
  //   title: "this.project.name",
  //   // Result: My Page Title ← My Site
  //   // If a child changes the title to "My Other Page Title",
  //   // it will become: My Other Page Title ← My Site
  //   titleTemplate: "%s ← My Site",
  //   // Define meta tags here.
  //   meta: [{ name: "description", content: "I have things here on my site." }]
  // },

  methods: {
    allLoaded() {
      setTimeout(
        function() {
          this.loaded = true;
        }.bind(this),
        1000
      );
    },
    visibilityChanged(isVisible, entry) {
      this.isVisible = isVisible;
      if (isVisible) {
        this.currentVisible = entry.target.getAttribute("data-index");
      }
    },
    scrollToSection(ref) {
      var id = ref + 1;
      var sectionRef = "section-" + id;
      var element = this.$refs[sectionRef];

      element.scrollIntoView({ behavior: "smooth" });
    },
    myFilter: function() {
      this.showMore = !this.showMore;
      this.showMoreText = this.showMore ? "Hide" : "More";
    },
    galleryImageFromElement(element) {
      return {
        url: element.url[4]["original"],
        alt: element.description || element.title || ""
      };
    },
    galleryPreviewShow: function(image) {
      const previewEl = document.querySelector(".project-image-preview");
      const previewImgEl = previewEl.querySelector("img");

      if (image && image.url) {
        previewImgEl.setAttribute("src", "");
        previewImgEl.setAttribute("src", image.url);
        previewImgEl.setAttribute("alt", image.alt || "image zoom preview");
        previewEl.classList.add("show");
      }
    },
    galleryPreviewHide: function() {
      const previewEl = document.querySelector(".project-image-preview");

      if (previewEl) {
        previewEl.classList.remove("show");
      }
    },
    mapFooterProject(projectData) {
      if (!projectData) {
        return {
          slug: "",
          title: "",
          img: ""
        };
      }

      const cover =
        Array.isArray(projectData.cover) && projectData.cover.length > 0
          ? projectData.cover[0]
          : projectData.cover || "";

      return {
        slug: projectData.slug || "",
        title: projectData.name || "",
        img: cover
      };
    },
    getPaginationUrls: function(currentSlug) {
      var self = this;

      fetchAllPages("https://api.blue-temple.com/projects?_with=tag")
        .then(function(allProjects) {

          const navigableProjects = allProjects
            .filter(obj => {
              const isFeatured = obj.tag && obj.tag.data && obj.tag.data.slug === "featured";
              const yearStr = String(obj.year || "").toLowerCase();
              const isFuture = yearStr === "future";
              return !isFeatured && !isFuture;
            })
            .sort((a, b) => (a.year > b.year ? -1 : 1));

          const currentIndex = navigableProjects.findIndex(
            obj => obj.slug === currentSlug
          );

          if (currentIndex === -1) {
            self.prevProject = self.mapFooterProject(null);
            self.nextProject = self.mapFooterProject(null);
            self.lastProject = self.mapFooterProject(
              navigableProjects[navigableProjects.length - 1]
            );
            self.firstProject = self.mapFooterProject(navigableProjects[0]);
            return;
          }

          self.prevProject = self.mapFooterProject(navigableProjects[currentIndex - 1]);
          self.nextProject = self.mapFooterProject(navigableProjects[currentIndex + 1]);
          self.lastProject = self.mapFooterProject(
            navigableProjects[navigableProjects.length - 1]
          );
          self.firstProject = self.mapFooterProject(navigableProjects[0]);
        })
        .catch(function() {});
    },
    fetchData() {
      var self = this;

      axios
        .get(
          "https://api.blue-temple.com/projects" +
            "?slug=" +
            this.$route.params.slug +
            "&_with=status,location,type,galleries"
        )
        .then(function(data) {
          self.project = data.data.data[0];

          // cover seo
          if (self.project.coverSeo && self.project.coverSeo[0].alt) {
            self.coverSeo.alt = self.project.coverSeo[0].alt;
          }

          if (self.project.coverSeo && self.project.coverSeo[0].title) {
            self.coverSeo.title = self.project.coverSeo[0].title;
          }

          //
          self.projectTitle = data.data.data[0].name;
          self.projectMetaDescription = data.data.data[0].info;

          // get small gallery
          let smallImgsObj = self.project.galleries.data.filter(obj => {
            return obj.extraData.gallery === "small";
          });

          // push small gallery img urls
          if (smallImgsObj[0]) {
            self.smallGalleryImages = [];
            smallImgsObj[0].images.data.forEach(element => {
              self.smallGalleryImages.push(self.galleryImageFromElement(element));
            });
          } else {
            self.smallGalleryImages = [];
          }

          // get large gallery
          let largeImgsObj = self.project.galleries.data.filter(obj => {
            return obj.extraData.gallery === "big";
          });

          // push large gallery img urls
          if (largeImgsObj[0]) {
            self.largeGalleryImages = [];
            largeImgsObj[0].images.data.forEach(element => {
              self.largeGalleryImages.push(self.galleryImageFromElement(element));
            });
          } else {
            self.largeGalleryImages = [];
          }

          self.$nextTick(function() {
            self.$refs.hooper.update();
            // self.$refs.carousel.reload();
            // self.$refs.slick.reInit();
            // self.$refs.carousel.reload();
          });

          // set pagination urls based on homepage ordering
          self.getPaginationUrls(self.project.slug);

          // set custom color
          if (self.project.color) {
            self.customColor = self.project.color;
          } else {
            self.customColor = "#ffffff";
          }

          // all ready
          self.allLoaded();

          // render embed
          // if (self.project.intro) {
          //   document.querySelector(".project-embed").innerHTML =
          //     self.project.intro;
          // }
        })
        .catch(function() {});
    },
    getSocialNetworks() {
      var self = this;

      axios
        .get("https://api.blue-temple.com/configuration")
        .then(function(res) {
          var fb_url = res.data.data.filter(obj => {
            return obj.key === "Social_Facebook";
          });
          self.socialUrls.fb = fb_url[0].defaultValue;
          //
          var ig_url = res.data.data.filter(obj => {
            return obj.key === "Social_Instagram";
          });
          self.socialUrls.ig = ig_url[0].defaultValue;
          //
          var li_url = res.data.data.filter(obj => {
            return obj.key === "Social_Linkedin";
          });
          self.socialUrls.li = li_url[0].defaultValue;

          var email_url = res.data.data.filter(obj => {
            return obj.key === "Social_Mail";
          });
          self.socialUrls.email = email_url[0].defaultValue;
        })
        .catch(function() {});
    }
  },
  metaInfo() {
    return {
      title: "blue temple | " + this.projectTitle,
      meta: [
        {
          name: "description",
          content: this.projectMetaDescription
        }
      ]
    };
  },
  watch: {
    "$route.params": {
      handler(newValue) {
        const { slug } = newValue;
        this.fetchData(slug);
      },
      immediate: true
    }
  },
  created: function() {
    this.getSocialNetworks();
  },
  mounted() {
    // console.log(this.$refs);
    // console.log(this.$refs.carousel);
    // setTimeout(function() {
    // this.$refs.slick.goTo(1);
    // this.$refs.slick.reInit();
    // }, 2000);
  },
  computed: {
    cssProps() {
      return {
        "--accent-color": this.customColor
      };
    }
  },
  beforeCreate: function() {
    document.body.className = "class-project";
  }
};
</script>

<style lang="scss">
.class-project {
  #nav {
    // background-color: $color-light;

    // nav:after {
    //   display: none;
    // }

    // .header-wrapper-content {
    //   opacity: 0 !important;
    // }
  }
}

.left-container {
  position: absolute;
  top: 0;
  left: 0;
  display: none;
  width: calc(25vw + 2px);
  height: 100vh;
  padding: 22px;
  background: white;

  h1 {
    font-size: 27px;
    color: $color-darkgrey;
  }

  &-d-title-col--r90deg {
    display: none;
  }

  &-d-title-col--normal {
    display: block;
  }

  img {
    width: 100%;
    min-height: 84px;
    margin-top: 24px;
    background-color: $color-darkgrey;
  }

  &-title {
    display: block;
    font-family: "rajdhanibold";
    font-size: 18px;
    color: $color-darkgrey;
  }

  &-type {
    display: block;
    margin-bottom: 30px;
    font-family: "rajdhaniregular";
    font-size: 18px;
    color: $color-darkgrey;
  }

  &-scale,
  &-location,
  &-chronology,
  &-status,
  &-download,
  &-backtoproject {
    display: block;
    font-family: "rajdhaniregular";
    font-size: 14px;
    text-decoration: none;
    color: $color-darkgrey;
  }

  &-location {
    margin-top: 10px;
  }

  &-download,
  &-backtoproject {
    margin-bottom: 5px;
    line-height: 16px;
    text-transform: lowercase;

    &:hover {
      cursor: url("~@/assets/images/cursor-hover.png") 24 24, auto;
      font-family: "rajdhanibold";
      text-transform: uppercase;
    }
  }

  p.left-container-excerpt {
    display: none;
    margin: 0;
    font-family: "rajdhaniregular";
    font-size: 14px;
    color: $color-darkgrey;
  }

  &-status {
    font-family: "rajdhanibold";
    text-transform: uppercase;
  }

  /* */
  .footer {
    .menu-social {
      svg {
        fill: $color-darkgrey;

        &:hover {
          cursor: url("~@/assets/images/cursor-hover.png") 24 24, auto;
          fill: $color-darkgrey;
        }
      }
    }

    .get-involved-cta {
      color: $color-darkgrey;

      &:hover {
        cursor: url("~@/assets/images/cursor-hover.png") 24 24, auto;
        font-family: "rajdhanibold";
      }
    }
  }
}

.ruler-indicator {
  display: none;
}

.load-it {
  display: none;
}

.project {
  &-image-preview {
    display: none;
  }

  .slick-slider {
    .slick-prev,
    .slick-next {
      &:hover {
        cursor: url("~@/assets/images/cursor-hover.png") 24 24, auto;
      }

      &:before {
        background-color: var(--accent-color);
      }
    }

    .slick-dots {
      li {
        display: inline-block;

        &.slick-active {
          button {
            &:before {
              background: var(--accent-color);
            }
          }
        }

        button {
          &:hover {
            cursor: url("~@/assets/images/cursor-hover.png") 24 24, auto;

            &:before {
              // background: darken($customColor, 20%);
            }
          }

          &:before {
            border: 2px solid var(--accent-color);
          }
        }
      }
    }

    @media screen and (max-width: 768px) {
      display: none;
    }
  }

  .mobile-gallery {
    display: none;
  }

  @media screen and (max-width: 768px) {
    .mobile-gallery {
      display: block;
      padding: 0 20px 40px;

      img {
        display: block;
        width: 100%;
      }
    }
  }

  &-section {
    margin: 0 20px 40px;

    &--wide {
      margin: 0 0 20px 0;

      .project-embed {
        @media screen and(max-width: 1024px) {
          iframe {
            width: 100%;
            min-height: 230px;
          }
          
          p > img {
            width: 100vw !important;
          }
        }
      }
    }

    &--border {
      border-top: 5px solid $color-light;
    }

    &--d {
      display: none;
    }

    &--hero {
      &--d {
        display: none;
      }

      a {
        display: none;
      }
    }

    &--images {
      @media screen and (max-width: 768px) {
        border-bottom: 5px solid #fff;
        padding-bottom: 40px;
      }
    }

    &-more {
      font-family: "rajdhanibold";
      font-size: 14px;
      line-height: 20px;
      color: $color-light;
      text-decoration: none;
      text-transform: lowercase;

      &:hover {
        // cursor: pointer;
        cursor: url("~@/assets/images/cursor-hover.png") 24 24, auto;
        color: var(--accent-color);
        text-transform: uppercase;
      }
    }

    .tabs {
      margin-top: 10px;

      h5 {
        margin: 0;
        color: $color-grey-footer;

        &.active {
          color: var(--accent-color);
          // color: $color-light;
        }

        &:hover {
          // cursor: pointer;
          cursor: url("~@/assets/images/cursor-hover.png") 24 24, auto;
          color: var(--accent-color);
          // color: $color-light;
          opacity: 0.7;
        }
      }

      .tab-content-wrapper {
        display: block;
        max-height: 90px;
        overflow: hidden;

        &.active {
          max-height: none;
        }
      }
    }

    &--footer {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: calc(100% - 40px);
      height: 90px;
      margin-bottom: 0;

      &-block {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 50%;
        height: auto;

        &:nth-child(1) {
          justify-content: flex-start;

          a {
            text-align: left;
          }
        }

        &:nth-child(2) {
          justify-content: flex-end;

          a {
            text-align: right;
          }
        }

        &:hover {
          // cursor: pointer;
          cursor: url("~@/assets/images/cursor-hover.png") 24 24, auto;
          opacity: 1;
        }

        a {
          display: block;
          font-family: "rajdhanibold";
          font-size: 16px;
          text-align: center;
          text-transform: uppercase;
          text-decoration: none;
          color: $color-light;

          span {
            display: block;
            font-family: "rajdhaniregular";
            text-transform: lowercase;
          }
        }
      }
    }

    &--contact {
      a {
        font-family: "rajdhaniregular";
      }

      span,
      a {
        display: block;
        font-family: "rajdhanibold";
        font-size: 14px;
        line-height: 18px;
        color: $color-light;
        text-decoration: none;
        text-align: right;
      }
    }
  }

  &-image {
    display: block;
    width: 100%;
    height: auto;
    margin-bottom: 20px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  &-hero {
    display: block;
    width: 100%;
    height: auto;
    max-height: 260px;
    object-fit: cover;
  }

  h2,
  h3,
  h5 {
    margin: 0;
    padding: 0;
    font-size: 26px;
    line-height: 26px;
    color: $color-light;
  }

  h2 {
    font-family: "rajdhanibold";
  }

  h3 {
    font-family: "rajdhaniregular";
    font-weight: normal;
  }

  h5 {
    margin: 20px 0;
    font-family: "rajdhanibold";
    text-transform: uppercase;
  }

  p {
    display: block;
    margin: 20px 0;
    font-family: "rajdhaniregular";
    font-size: 14px;
    line-height: 20px;
    color: $color-light;
    white-space: pre-wrap;
  }

  &--cols {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;

    p {
      margin-top: 0;
    }

    .project-section--nomargin {
      margin: 80px 0 0;
    }
  }

  .team-members {
    display: flex;
    flex-direction: column;
    list-style: none;
    columns: 2;
    -webkit-columns: 2;
    -moz-columns: 2;
  }

  li {
    display: block;
    font-family: "rajdhaniregular";
    font-size: 14px;
    line-height: 20px;
    color: $color-light;

    a {
      color: inherit;
      text-decoration: none;
      line-height: 22px;

      &:hover {
        color: var(--accent-color);
        // cursor: pointer;
        cursor: url("~@/assets/images/cursor-hover.png") 24 24, auto;
        font-family: "rajdhanibold";
      }
    }
  }

  &-section-inner {
    width: 100%;

    div {
      width: calc(50% - 10px);
    }

    &--col {
      display: flex;
      flex-direction: column;

      
    }
    
    // Hide project-section-inner--1 with project--cols on mobile
    @media screen and (max-width: 768px) {
      &--1.project--cols {
        display: none !important;
      }

      &.project-section-inner--2 {
        .tab-content-wrapper {
          display: block;
          width: 100%;
          max-height: 90px;
          overflow: hidden;

          &.active {
            max-height: none;
          }
        }
      }
    }
  }

  &-icon {
    display: block;
    width: 150px;
    height: 150px;
    object-fit: cover;
    // background-image: url("../assets/images/project_icon_1.png");
    background-size: cover;
    background-position: 0 0;
  }

  &-details {
    h4 {
      font-family: "rajdhaniregular";
      font-weight: normal;
      font-size: 18px;
      line-height: 22px;
      color: $color-light;

      span {
        display: block;
        margin: 2px 0;
      }

      a {
        font-size: 14px;
        color: $color-light;
        text-decoration: none;
      }
    }
  }

  &-section--contact {
    p {
      white-space: normal;
    }
  }

  &-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 90px;
    padding-top: 80px;

    &-block {
      display: flex;
      justify-content: center;
      align-items: flex-start;
      width: calc(50% - 2px);
      height: 90px;
      background-size: cover;
      background-repeat: none;
      background-position: center center;
      opacity: 1;
      transition: opacity 0.3s ease;
      text-decoration: none;

      &:nth-child(1) {
        justify-content: flex-start;
        padding-left: 6.25vw;

        a {
          transform: translate3d(0, -50px, 0);
          text-align: left;
          opacity: 1;
          transition: all 0.3s ease;
        }
      }

      &:nth-child(2) {
        justify-content: flex-end;
        padding-right: 6.25vw;

        a {
          transform: translate3d(0, -50px, 0);
          text-align: right;
          opacity: 1;
          transition: all 0.3s ease;
        }
      }

      &:hover {
        // cursor: pointer;
        cursor: url("~@/assets/images/cursor-hover.png") 24 24, auto;
        opacity: 1;
      }

      a {
        display: block;
        font-family: "rajdhanibold";
        font-size: 16px;
        text-align: center;
        text-transform: uppercase;
        text-decoration: none;
        color: $color-light;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;

        span {
          display: block;
          font-family: "rajdhaniregular";
          text-transform: none;
        }
      }
    }
  }
}

@media screen and (min-width: 768px) {
  .left-container {
    display: block;
    width: calc(25vw + 2px);
    z-index: 100;
    border-top: 2px solid $color-darkgrey;
    border-bottom: 2px solid $color-darkgrey;
    border-left: 2px solid $color-darkgrey;

    &-content {
      height: 100%;
      transform: translate3d(0, 0, 0);
      transition: all 0.3s ease;
      opacity: 1;

      .left-container-backtoproject,
      .left-container-download {
        transform: translate3d(0, 0, 0);
        transition: all 0.3s ease;
        opacity: 1;
      }

      &.anim {
        .left-container-backtoproject,
        .left-container-download {
          transform: translate3d(-100px, 0, 0);
          opacity: 0;
        }
      }
    }

    .footer {
      bottom: 0;
    }
  }

  .project-embed {
    position: relative;
    padding-bottom: 54.25%;
    padding-top: 25px;
    height: 0;
    width: 100%;
    // height: calc(100% - 120px);
    visibility: hidden;
    opacity: 0;

    &.show {
      visibility: visible;
      opacity: 1;
    }

    img {
      position: absolute;
      top: 0;
      left: 0;
      width: 100% !important;
      height: 100% !important;
      object-fit: cover;
    }

    img,
    iframe {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;

      &[src*="modelo"] {
        height: calc(100vh - 120px);
      }
    }

    video,
    iframe {
      width: 100%;
      height: 100%;
    }
  }

  .load-it {
    position: absolute;
    z-index: 100;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    display: block;
    width: 180px;
    height: 50px;
    margin: 45vh auto auto auto;
    border: 5px solid var(--accent-color);
    background: transparent;
    font-family: "rajdhanibold";
    font-size: 24px;
    line-height: 42px;
    color: var(--accent-color);
    outline: none;

    &:hover {
      cursor: url("~@/assets/images/cursor-hover.png") 24 24, auto;
    }
  }

  .ruler-indicator {
    position: absolute;
    top: 0;
    left: 25vw;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    z-index: 10;

    @for $i from 1 through 5 {
      &[data-index="#{$i}"] {
        > div:nth-child(#{$i}) {
          li {
            &.number {
              transform: translate3d(-7px, 0, 0) scale(1);
              color: var(--accent-color);
            }

            &:nth-child(2),
            &:nth-child(6) {
              transform: translate3d(-22px, 0, 0);
            }

            &:nth-child(3),
            &:nth-child(5) {
              transform: translate3d(-14px, 0, 0);
            }
          }
        }
      }
    }

    &-block {
      display: block;
      height: 20vh;
      margin: 0 0 -2px 0;
      transform: translate3d(0, 0, 0);
      transition: all 0.3s ease;
      opacity: 1;

      &:nth-child(1) {
        transition-delay: 0.2s;
      }

      &:nth-child(2) {
        transition-delay: 0.3s;
      }

      &:nth-child(3) {
        transition-delay: 0.4s;
      }

      &:nth-child(4) {
        transition-delay: 0.5s;
      }

      &:nth-child(5) {
        transition-delay: 0.6s;
      }

      &.anim {
        transform: translate3d(-100px, 0, 0);
        opacity: 0;
      }

      &:hover {
        cursor: url("~@/assets/images/cursor-hover.png") 24 24, auto;
        // cursor: pointer;

        li {
          &.number {
            transform: translate3d(-7px, 0, 0) scale(1);
            color: var(--accent-color);

            span {
              display: block;
              transform: translate3d(56px, -5px, 0);
              visibility: visible;
            }
          }

          &:nth-child(2),
          &:nth-child(6) {
            // width: 38px;
            transform: translate3d(-22px, 0, 0);
          }

          &:nth-child(3),
          &:nth-child(5) {
            // width: 48px;
            transform: translate3d(-14px, 0, 0);
          }

          &:nth-child(4) {
            // transform: translate3d(12px, 0, 0) scale(1);
          }
        }
      }

      ul {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        height: 100%;

        li {
          transform: translate3d(-12px, 0, 0);
          transition: all 0.1s ease;

          &.line {
            width: 48px;
            height: 2px;
            background: rgba(255, 255, 255, 0.7);
            transform: translate3d(-30px, 0, 0);
          }

          &.number {
            position: relative;
            font-family: "rajdhanibold";
            font-size: 44px;
            color: rgba(255, 255, 255, 0.7);
            transform: translate3d(-7px, 0, 0) scale(0.8);
            backface-visibility: hidden;
            -webkit-font-smoothing: subpixel-antialiased;

            span {
              position: absolute;
              top: 0;
              left: 0;
              display: block;
              visibility: hidden;
              width: auto;
              padding: 5px 18px;
              font-family: "rajdhanibold";
              font-size: 14px;
              color: $color-dark;
              white-space: nowrap;
              background: var(--accent-color);
              transform: translate3d(48px, -5px, 0);
              // transform: translate3d(-10px, 0, 0) scale(0.5);
              transition: all 0.3s ease 0.05s;
              backface-visibility: hidden;
              -webkit-font-smoothing: subpixel-antialiased;
            }
          }

          &:nth-child(2),
          &:nth-child(6) {
            transition-delay: 0.05s;
          }

          &:nth-child(3),
          &:nth-child(5) {
            transition-delay: 0.05s;
          }

          &:nth-child(4) {
            transition-delay: 0s;
          }
        }
      }
    }
  }

  .project {
    width: 100%;
    height: 100vh;
    overflow-x: hidden;
    overflow-y: scroll;

    h5 {
      font-size: 24px;
    }

    p {
      margin-bottom: 0;
    }

    &-section {
      margin-bottom: 20px;

      &--hero {
        position: relative;
        display: block;
        width: 100% !important;
        height: 100vh;

        &--d {
          display: block;
        }

        &--m {
          display: none;
        }

        img {
          display: block;
          height: 100%;
          max-height: 100%;
        }

        a {
          position: absolute;
          right: 0;
          bottom: 10px;
          left: 0;
          display: block;
          width: 120px;
          height: 68px;
          margin: 40px auto 0;

          &:hover {
            cursor: url("~@/assets/images/cursor-hover.png") 24 24, auto;
            // cursor: pointer;
          }

          svg {
            display: block;
            width: 120px;
            height: 68px;
            fill: $color-light;
          }
        }
      }

      &--contact {
        .contact-wrapper {
          display: flex;
          flex-direction: row;
          justify-content: space-between;

          p {
            width: calc((100% / 3) * 2 - 30px);
            white-space: normal !important;
          }

          > div {
            width: calc(100% / 3 - 30px);
            margin: 20px 0 0;
          }

          span,
          a {
            display: block;
            font-family: "rajdhanibold";
            font-size: 20px;
            line-height: 26px;
            color: $color-light;
            text-decoration: none;
          }
          a {
            font-family: "rajdhaniregular";
          }

          a:hover {
            // cursor: pointer;
            cursor: url("~@/assets/images/cursor-hover.png") 24 24, auto;
            color: var(--accent-color);
          }
        }
      }

      &--d {
        display: block;
      }

      &--m {
        display: none;
      }

      &--images {
        columns: 2;
        -webkit-columns: 2;
        -moz-columns: 2;
      }

      &-inner {
        &--1 {
          width: calc(100% / 3 - 10px);

          div {
            width: 100%;
          }

          @media screen and (max-width: 768px) {
              &.project--cols {
                display: none !important;
              }
          }
        }

        &--2 {
          width: calc((100% / 3) * 2 - 10px);

          div {
            width: 100%;
          }
        }

        .tab-content-wrapper {
          display: block;
          max-height: 90px;
          overflow: hidden;

          &.active {
            max-height: none;
          }
        }
      }

      .project-icon {
        width: 170px;
        height: 170px;
        // background-image: url("../assets/images/project_icon_1.png");
        background-size: cover;
        background-position: 0 0;
        // transform: scale(1.6);
        animation: play 5.1s steps(141) infinite;

        @keyframes play {
          from {
            background-position: 0 0;
          }
          to {
            background-position: 0 -23970px;
          }
        }
      }

      &--d-wrapper {
        display: flex;
        flex-direction: row;
        justify-content: space-between;

        & > div {
          width: calc(100% / 3 - 10px);
        }

        & > div + div:not(.project-section-inner--1) {
          width: calc((100% / 3) * 2 - 10px);
          margin-left: 0;
        }

        .team-members {
          list-style: none;
          columns: 1;
          -webkit-columns: 1;
          -moz-columns: 1;
        }
      }

      &--links {
        display: flex;
        flex-direction: row;
        justify-content: space-between;

        & > div {
          width: calc(100% / 2);
        }

        & > div:first-child {
          margin-right: 30px !important;
        }

        & > div:last-child {
          margin-left: 30px !important;
          text-align: right;
        }
      }

      &--footer {
        &-block {
          a {
            span {
              line-height: 20px;
            }
          }
        }
      }
    }

    &--cols {
      margin-bottom: 20px;
    }
  }
}

/* desktop */
@media screen and (min-width: 1024px) {
  .left-container {
    h1 {
      font-size: 3.5vw;
    }

    img {
      max-height: 208px;
      object-fit: cover;
    }

    .footer {
      left: 22px;
    }
  }

  .chapter {
    &-line {
      position: relative;

      &:after {
        content: "";
        position: absolute;
        bottom: -60px;
        left: -6.25vw;
        width: 100vw;
        height: 2px;
        background-image: linear-gradient(
          to right,
          #969696 55%,
          rgba(255, 255, 255, 0) 20%
        );
        background-position: top;
        background-size: 18px 2px;
        background-repeat: repeat-x;
      }
    }

    &-margintop {
      /* avoid margins collapsing */
      padding-top: 60px;

      &--nopadding {
        padding-top: 0;
        margin-top: 120px;
      }
    }

    &-marginbottom {
      margin-bottom: 60px !important;
    }
  }

  .project {
    &-image-preview {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 25vw;
      display: flex;
      justify-content: center;
      align-items: center;
      visibility: hidden;
      width: calc(75% - 25vw);
      height: auto;
      max-height: 55vh;
      margin: auto;
      pointer-events: none;
      z-index: 9900;
      opacity: 0;
      transition: opacity 0.2s ease 0.2s;

      &.show {
        opacity: 1;
        visibility: visible;
      }

      img {
        display: block;
        width: auto;
        max-width: 50vw;
        height: auto;
        max-height: 65vh;
        margin: auto;
        // object-fit: contain; //prevent the image from cropping or not filling the space
        border: 2px solid var(--accent-color);
      }
    }

    &-section {
      margin: 0 6.25vw 60px;

      &--hero {
        width: calc(100% - 12.5vw);
        margin: 0 0 60px 0;
      }

      .project-icon {
        width: 170px;
        height: 170px;
        margin-top: 50px;
        margin-left: 50px;
        // background-image: url("../assets/images/project_icon_1.png");
        background-size: cover;
        background-position: 0 0;
        transform: scale(1.6);
        animation: play 5.1s steps(141) infinite;

        @keyframes play {
          from {
            background-position: 0 0;
          }
          to {
            background-position: 0 -23970px;
          }
        }
      }

      &-inner {
        &--1 {
          width: calc(100% / 3 - 30px);

          div {
            width: 100%;
          }
        }

        &--2 {
          width: calc((100% / 3) * 2 - 30px);

          div {
            width: 100%;
          }
        }
      }

      &--images {
        columns: 4;
        -webkit-columns: 4;
        -moz-columns: 4;

        &:hover {
          cursor: url("~@/assets/images/cursor-hover.png") 24 24, auto;

          .project-image:not(:hover) {
            opacity: 0.5;
          }
        }

        .project-image {
          width: 100%;
          height: auto;
          max-width: 265px;
          max-height: 165px;
          object-fit: contain;
          transition: opacity 0.2s ease;

          &:hover {
            // cursor: pointer;
            cursor: url("~@/assets/images/cursor-hover.png") 24 24, auto;
          }
        }
      }

      &--d-wrapper {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        margin: 0 6.25vw;

        & > div {
          width: calc(100% / 3 - 30px);
          margin: 0 0 40px;
        }

        & > div + div:not(.project-section-inner--1) {
          width: calc((100% / 3) * 2 - 30px);
          margin-left: 0;
        }
      }

      &-more {
        display: block;
        margin-top: 50px;
        font-size: 22px;
      }
    }

    h5 {
      font-size: 42px;
      line-height: 42px;
    }

    p:not(.left-container-excerpt) {
      font-size: 20px;
      line-height: 30px;
      white-space: pre-wrap;
    }

    p.project-section-content-text,
    li {
      font-size: 20px;
      line-height: 26px;
    }

    &-footer {
      height: 50px;
      align-items: flex-start;
      margin-top: 70px;

      &-block {
        height: 50px;
        align-items: flex-start;
        opacity: 1;

        &:nth-child(1) {
          justify-content: flex-start;
          padding-left: 6.25vw;

          a {
            transform: translate3d(0, -60px, 0);
            text-align: left;
            opacity: 1;
            transition: all 0.3s ease;
          }
        }

        &:nth-child(2) {
          justify-content: flex-end;
          padding-right: 6.25vw;

          a {
            transform: translate3d(0, -60px, 0);
            text-align: right;
            opacity: 1;
            transition: all 0.3s ease;
          }
        }

        // &:hover {
        //   a {
        //     transform: translate3d(0, -80px, 0);
        //     opacity: 1;
        //   }
        // }

        a {
          font-size: 20px;

          &:hover {
            cursor: url("~@/assets/images/cursor-hover.png") 24 24, auto;
          }

          span {
            font-size: 20px;
            line-height: 20px;

            &:hover {
              cursor: url("~@/assets/images/cursor-hover.png") 24 24, auto;
              font-family: "rajdhanibold";
              text-transform: uppercase;
            }
          }
        }
      }
    }
  }
}

/* desktop */
@media screen and (min-width: 1440px) {
  .left-container {
    padding: 3.1vw;

    img {
      min-height: 165px;
      margin-top: 0;
    }

    &-title,
    &-type {
      font-size: 38px;
      line-height: 40px;
    }

    &-d-wrapper {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: flex-start;
      margin-top: 30px;

      .project-section {
        margin: 0 0 40px;
      }
    }

    &-d-title-col {
      margin-right: 3.1vw;
      margin-bottom: 90px;
      margin-left: -5px;
      writing-mode: vertical-rl;
      text-orientation: mixed;
      transform: rotate(-180deg);
      text-align: right;

      &--r90deg {
        display: block;
      }

      &--normal {
        display: none;
      }

      .left-container-type {
        margin-bottom: 0;
      }
    }

    &-d-content {
      margin-top: 0;
    }

    p.left-container-excerpt {
      display: block !important;
      margin-bottom: 50px !important;
    }

    .footer {
      left: 0;
    }
  }

  .fullheight {
    height: 100vh;
  }

  .height50 {
    min-height: calc(50vh - 60px);
  }

  .height25 {
    height: calc(25vh - 60px);
  }
}
</style>
